<div>
  <h1 mat-dialog-title>Controllo Itinerario</h1>
  <span fxFlex></span>
  <button
    mat-icon-button
    aria-label="Chiudi"
    [mat-dialog-close]
    class="mat-dialog-close"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <div>
    <app-itinerary-checkup
      (errorClick)="close()"
      [errors]="itineraryCheckupErrors"
      (validate)="isItineraryValid = $event"
    ></app-itinerary-checkup>
  </div>
  <p *ngIf="!isItineraryValid">
    I problemi dovranno essere risolti prima di poter consegnare l'itinerario.
  </p>
</div>
<div mat-dialog-actions>
  <span fxFlex></span>
  <button mat-raised-button color="primary" [mat-dialog-close] cdkFocusInitial>
    Ok, chiudi
  </button>
</div>
